
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[taxonomyFrontendSlug]/[taxonomyItemSlug]",
      function () {
        return require("private-next-pages/[taxonomyFrontendSlug]/[taxonomyItemSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[taxonomyFrontendSlug]/[taxonomyItemSlug]"])
      });
    }
  